import { User } from "oidc-client-ts";
import { GetTokenManually } from "./WebPortalTokenClient";

function timer(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

export async function fetchRetry(url: RequestInfo, options: RequestInit, retries: number, delay: number): Promise<Response> {

    for (; retries > 0; retries--) {

        const response = await fetch(url, options);

        if (response.ok)
            return response;

        await timer(delay);
    }
}

export async function authenticatedFetchRetry(authUser: User, url: RequestInfo, init: RequestInit, retries: number, delay: number): Promise<Response> {
    for (; retries > 0; retries--) {
        try {

            const authInit = authUser?.access_token
                ? {
                    ...init,
                    credentials: 'same-origin',
                    headers: { ...init?.headers, 'Authorization': `Bearer ${GetTokenManually()?.access_token ?? authUser?.access_token}` },
                } as RequestInit
                : init;

            const response = await fetch(url, authInit);

            if (response.ok)
                return response;
        }
        catch (error) {
        }
        await timer(delay);
    }

    return Promise.reject();
}

export async function authenticatedFetchRetryWithErrors(authUser: User, url: RequestInfo, init: RequestInit, retries: number, delay: number, timeout = 60): Promise<Response> {
    for (; retries > 0; retries--) {
        try {
            const controller = new AbortController();
            setTimeout(() => controller.abort(), timeout * 1000);

            const authInit = authUser?.access_token
                ? {
                    ...init,
                    credentials: 'same-origin',
                    headers: { ...init?.headers, 'Authorization': `Bearer ${GetTokenManually()?.access_token ?? authUser?.access_token}` },
                    signal: controller.signal
                } as RequestInit
                : init;

            const response = await fetch(url, authInit);

            if (response.ok || response.status == 400)
                return response;
        }
        catch (error) { }
        await timer(delay);
    }

    return Promise.reject();
}

export async function authenticatedFetchRetryWithAbort(authUser: User, url: RequestInfo, init: RequestInit, retries: number, delay: number, abortController?: AbortController): Promise<Response> {
    for (; retries > 0; retries--) {
        try {

            const authInit = authUser?.access_token
                ? {
                    ...init,
                    credentials: 'same-origin',
                    headers: { ...init?.headers, 'Authorization': `Bearer ${GetTokenManually()?.access_token ?? authUser?.access_token}` },
                    signal: abortController?.signal
                } as RequestInit
                : init;

            const response = await fetch(url, authInit);

            if (response.ok)
                return response;
        }
        catch (error) {
            if (abortController?.signal.aborted) {
                console.log('Request aborted');
                throw new Error('Request was cancelled');
            }
        }
        await timer(delay);
    }

    return Promise.reject();
}
